/*  Copyright 2021 Sebastian Spautz

    This File is Part of "RPGSheetManager - Forbidden Lands".

    "RPGSheetManager" is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    any later version.
    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.
    You should have received a copy of the GNU General Public License
    along with this program.  If not, see http://www.gnu.org/licenses/.
*/

/** Main modul for the Forbidden Lands character sheet
  * @module forbiddenlands.1.character
*/
import FormControls from '../../../node_modules/@sebastiansit/formoperator/src/main/scripts/components/formControls.mjs'
import * as formoperator from '../../../node_modules/@sebastiansit/formoperator/src/main/scripts/main.mjs'
import CollaborationConfig from '../general/scripts/collaborationConfig.js'

/** Inits the attribute section.
 *
 * @returns {undefined}
 */
function initAttributes () {
  const changeBaseHandler = (event) => {
    const base = event.target
    const damage = base.nextElementSibling.nextElementSibling

    damage.max = base.value
  }

  document.querySelectorAll('#attributes input:nth-of-type(2)').forEach((item, i) => {
    const damage = item
    const base = damage.previousElementSibling.previousElementSibling

    damage.max = base.value
  })

  document.querySelectorAll('#attributes input:first-of-type').forEach((item, i) => {
    item.addEventListener('change', changeBaseHandler)
  })
}

/** Inits the calculation of the carrying capacity.
 *
 * @returns {undefined}
 */
function initCarrying () {
  const capacityInput = document.getElementById('capacity')
  const capacityhalfInput = document.getElementById('capacityhalf')

  capacityInput.readOnly = true
  capacityhalfInput.readOnly = true

  /** Gets the Strenght.
   *
   * @returns {number} The actual Strength
   */
  function getStrength () {
    const strength = parseInt(document.getElementById('strength').value)
    if (isNaN(strength)) return 1
    return strength
  }

  capacityInput.value = getStrength() * 4
  capacityhalfInput.value = getStrength() * 2

  document.getElementById('strength').addEventListener('change', (event) => {
    const strength = parseInt(event.target.value)
    if (isNaN(strength)) return
    capacityInput.value = strength * 4
    capacityhalfInput.value = strength * 2
  })
}

document.addEventListener('DOMContentLoaded', (event) => {
  window.customElements.define('sit-formcontrols', FormControls)
  window.customElements.define('fl-collaborationconfig', CollaborationConfig)

  formoperator.loadInitial()
    .then(() => {
      initAttributes()
      initCarrying()
    })
    .then(() => {
      const viewModeParam = new URL(window.location.href).searchParams.get('viewmode')
      if (viewModeParam) {
        formoperator.switchViewMode(document.getElementById('formAnimal'), viewModeParam)
        document.body.classList.add(viewModeParam)
      }
    })
})
